import React from "react";
import ReactTable from "react-table";
import "react-table/react-table.css";
import { PropTypes } from 'prop-types';
import StatusBarCell from './cells/StatusBarCell';
import { possibleStatus } from './cells/StatusBarCell'
import DataTableHeader from "./DataTableHeader";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classnames from 'classnames';
import _ from './../../utils/ObjectUtils';
import Checkbox from './../fields/checkboxes/Checkbox';
import {I18n} from "react-redux-i18n";

class DataTable extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            extendedColumns: [],
            selected: {},
            selectAll: 0,
            numberOfSelectableRows: 0,
            tableData: []
            /*
                0 means unchecked,
                1 means checked,
                2 means indeterminate
            */
        }
    }

    componentDidMount() {
        this.setState({
            extendedColumns: this.processColumns(),
        })   
    }

    componentWillReceiveProps(nextProps) {
        const {
            data,
            selectedPage,
            sortDirection,
            sortProperty
        } = this.props;

        let refinedData = [...nextProps.data];
        let numberOfSelectableRows = 0;

        const {
            hasRowSelector,
            rowIsSelectable,
            selectedPage : newSelectedPage,
            sortDirection : newSortDirection,
            sortProperty : newSortProperty
        } = nextProps;

        if ( !_.equals(refinedData, data) || !_.equals(newSortProperty, sortProperty)
            || !_.equals(newSortDirection, sortDirection) || !_.equals(newSelectedPage, selectedPage)) {

            if(hasRowSelector) {
                refinedData = refinedData.map(
                    row => {
                        row.selectable = true;
                        if(!_.isUndefined(rowIsSelectable)) {
                            row.selectable = rowIsSelectable(row);
                        }
                        return row;
                    }
                );
                refinedData.forEach(row => {
                    if(row.selectable) {
                        numberOfSelectableRows++;
                    }
                });
            }
            this.setState({
                selected: {},
                selectAll: 0,
                tableData: refinedData,
                numberOfSelectableRows
            })
        } else {
            this.setState({
                tableData: refinedData,
            })
        }
    }
    
    processColumns = () => {
        const { columns, hasStatusBar, hasRowSelector, statusBarAccessor } = this.props;
        let extendedColumns = columns;

        if (hasStatusBar) {
            extendedColumns.unshift(generateStatusColumn(statusBarAccessor))
        }
        if (hasRowSelector) {
            extendedColumns.unshift(this.generateRowSelectorColumn())
        }

        return extendedColumns;
    };

    allOptionsAreSelected = selectedOptions => {
        const selectedEntries = Object.entries(selectedOptions);
        const { numberOfSelectableRows } = this.state;

        return numberOfSelectableRows === selectedEntries.length &&
            selectedEntries.filter(keyValuePair => keyValuePair[1] === false).length === 0
    };

    atLeastOneOptionSelected = selectedOptions => {
        const selectedEntries = Object.entries(selectedOptions);

        return selectedEntries.filter(keyValuePair => keyValuePair[1] === true).length >= 1
    };

    toggleRow = id => {
        const { selectAll } = this.state;

        let selectAllNewValue;
        let newSelected = this.state.selected;

        newSelected[id] = !newSelected[id];

        if(selectAll !== 1 && this.allOptionsAreSelected(newSelected)) {
            selectAllNewValue = 1;
        } else if(this.atLeastOneOptionSelected(newSelected)) {
            selectAllNewValue = 2;
        } else {
            selectAllNewValue = 0;
        }

        this.setState({
            selected: newSelected,
            selectAll: selectAllNewValue
        });
    };

    toggleSelectAll = () => {
        const {
            tableData,
            selectAll
        } = this.state;

        const newSelectAllValue = selectAll === 0 ? 1 : 0 ;

        let newSelected = {};

        tableData.forEach(d => {
            if(d.selectable) {
                newSelected[d.id] = newSelectAllValue === 1;
            }
        });

        this.setState({
            selected: newSelected,
            selectAll: newSelectAllValue
        });
    };

    getSortedComponent = columnId => {
        const { sortProperty, sortDirection } = this.props;
        const columnIsSorted = sortProperty === columnId;

        return <span style={{
            marginRight: "8px",
            color: "#9b9b9b",
            opacity: columnIsSorted ? "1" : "0.3"
        }}>
            {columnIsSorted ?
                sortDirection === 'DESC' ?
                    <FontAwesomeIcon icon={['fas', 'sort-down']} /> :
                    <FontAwesomeIcon icon={['fas', 'sort-up']} /> :
                <FontAwesomeIcon icon={['fas', 'sort']} />}
        </span>;
    };

    ThComponent = ({ toggleSort, className, children, theadColumnInfo, ...rest }) => {
        return (
            <div
                className={classnames('rt-th', className)}
                onClick={e => (toggleSort && toggleSort(e))}
                role="columnheader"
                tabIndex="-1"
                {...rest}
            >
               {theadColumnInfo.sortable && this.getSortedComponent(theadColumnInfo.id)} {children}
            </div>
        )
    };

    getTheadThProps = (state, rowInfo, column) => {
        return {
            theadColumnInfo: column,
            style: {
                boxShadow: 'none',
                alignItems: 'center'
            }
        }
    };

    getTdProps = (state, rowInfo, column) => {
        return {
            tdcolumninfo: column,
            style: {
                paddingTop: "5px",
                paddingBottom: "3px"
            }
        }
    };

    generateRowSelectorColumn = () => {
        return ({
            id: "checkbox",
            accessor: "checked",
            sortable: false,
            width: 50,
            Cell: ({ original }) => {
                return (
                    <Checkbox
                        checked={original.checked}
                        disabled={!original.selectable}
                        onChange={() => this.toggleRow(original.id)}
                    />
                );
            },
        });
    };

    render() {
        const { 
            extendedColumns, 
            selected, 
            selectAll,
            tableData,
            numberOfSelectableRows
        } = this.state;

        const {
            pages,
            selectedPage,
            pageSize,
            totalElements,
            sortDirection,
            sortProperty,
            pageSizeOptions,
            onPageChange,
            onPageSizeChange,
            onSortChanged = () => { },
            onRowClick = () => { },
            hasRowSelector,
            customMultiSelectOptions,
            hasEdit,
            hasDelete,
            hasHeader = true,
            rowIsClickable = true,
            suppressBorders,
        } = this.props;

        let tableDataWithCheckedRows = tableData.map(d => ({
            ...d,
            checked: _.isNil(selected[d.id]) ? false : selected[d.id]
        }));

        const numberOfSelectedEntries = Object.entries(selected).filter(keyValuePair => keyValuePair[1] === true).length;

        const style = suppressBorders ? {borderStyle : "none"} : null;

        let correctedPageSize = pageSize;

        if (tableData.length === 0) correctedPageSize = 0;

        return <>
            { hasHeader && <DataTableHeader
                pages={pages}
                page={selectedPage}
                pageSize={correctedPageSize}
                totalElements={totalElements}

                hasRowSelector={hasRowSelector}
                selectAll={selectAll}
                customMultiOptions={customMultiSelectOptions}
                toggleSelectAll={this.toggleSelectAll}
                numberOfSelectableRows={numberOfSelectableRows}
                selectedEntries={selected}
                numberOfSelectedEntries={numberOfSelectedEntries}
                
                pageSizeOptions={pageSizeOptions}
                onPageChange= {onPageChange}
                onPageSizeChange= {onPageSizeChange}

                hasEdit={hasEdit}
                hasDelete={hasDelete}
            /> }
            <ReactTable className="px-4 -highlight"
                style = {style}
                //Table Data and format
                data={tableDataWithCheckedRows}
                sortable={false}
                columns={extendedColumns}
                NoDataComponent={NoDataComponent}
                sorted={[{
                    id: sortProperty,
                    desc: sortDirection === 'DESC'
                }]}

                onSortedChange={onSortChanged}

                //Forced props
                manual
                resizable={false}
                showPaginationTop={false}
                showPaginationBottom={false}
                minRows={tableData.length !== 0 ? tableData.length : correctedPageSize}
                ThComponent={this.ThComponent}
                getTheadThProps={this.getTheadThProps}
                getTdProps={this.getTdProps}
                getTrProps = {
                    (state, rowInfo) => ({
                        onClick: () => onRowClick(rowInfo.row._original),
                        style: {
                            cursor: rowIsClickable? 'pointer' : 'cursor'
                        }
                    })
                }
            />
        </>
    }
}

const generateStatusColumn = (accessor) => {
    return ({
        Header: "",
        id: "statusBar_reserved",
        accessor: accessor,
        minWidth: 10,
        Cell: (row) => <StatusBarCell
            color={row.value.color}
            id={row.value.id}
        />
    });
};

const NoDataComponent = (props) => {
    const {
        children
    } = props;

    return children === '' ?
        null :
        (
            <div className="datatable-nodata-text">
                {I18n.t("dataTable.noData")}
            </div>
        );
};

DataTable.defaultProps = {
    pageSize: 10,
    pageSizeOptions: [10, 20, 50],
    hasStatusBar: false,
    hasRowSelector: false,
    suppressBorders: false,
};

DataTable.propTypes = {
    data: PropTypes.array.isRequired,
    columns: PropTypes.array.isRequired,
    pages: PropTypes.number,
    selectedPage: PropTypes.number,
    pageSize: PropTypes.number,
    sortDirection: PropTypes.oneOf(['DESC', 'ASC']),
    sortProperty: PropTypes.string,
    pageSizeOptions: PropTypes.arrayOf(PropTypes.number),
    onPageChange:PropTypes.func,
    onPageSizeChange: PropTypes.func,
    onRowClick: PropTypes.func,
    hasStatusBar: PropTypes.bool,
    hasRowSelector: PropTypes.bool,
    statusBarAccessor: PropTypes.func,
    customMultiSelectOptions: PropTypes.array,
    hasEdit: PropTypes.bool,
    hasDelete: PropTypes.bool,
    hasHeader: PropTypes.bool,
    suppressBorders: PropTypes.bool,
};

export { possibleStatus };
export default DataTable;